/// <reference path='../_all.ts' />

module library {
  'use strict';


  export class DocumentCategory {
    constructor(
      public DocumentCategoryID : number,
      public DocumentCategoryName : string,
      public Types : DocumentType[]
      ) { }
  }

  export class DocumentType {
    constructor(
      public DocumentTypeID : number,
      public DocumentTypeName : string,
      public Documents : Document[]
      ) { }
  }

  export class Document {
    constructor(
      public DocumentID : number,
      public DocumentTitle : string,
      public DocumentTypeName : string,
      public DocumentContentName : string,
      public DocumentCategoryName : string,
      public SortOrder : number,
      public Revisions : DocumentRev[]
      ) { }
  }

  export class DocumentRev {
    constructor(
      public DocumentFileSrcID : number,
      public DocumentFileSrcRevID : number,
      public DocumentRevDestID : number,
      public DocumentRevDestSize : number,
      public DocumentRevDestName : string,
      public FileTypeExt : string,
      public FileTypeName: string,
      public FileTypeIsImage: boolean,
      public LanguageCode : string,
      public DocumentFileSrcName : string,
      public DocumentFileSrcRevName : string,
      public DocumentFullFileName : string,
      public DocumentRevDestHeightPx : string,
      public DocumentRevDestWidthPx : string,
      public Replaced : boolean,
      public Level : number,
      public ReleaseDate : Date,
      public DocumentFileSrcRevExpirationDate : Date,
      public DocumentFileSrcRevValidityDate : Date,
      public lastErrataDstDate : Date,
      public lastErrataDstID : number,
      public DocumentStateTypeName : number
      ) { }
  }

  export class ReplacedByData {
    constructor(
      public DocumentFileSrcRevID : string,
      public DocumentFileSrcName : string
    ) { }
  }

  export class DocumentCrossReferenceType {
    constructor(
      public DocumentCrossReferenceTypeID : number,
      public DocumentCrossReferenceTypeName : string,
      public Revisions : DocumentCrossReferenceRevDetails[]
      ) { }
  }

  export class DocumentCrossReferenceRevDetails {
    constructor(
      public DocumentFileSrcRevID : number,
      public DocumentFileSrcName : string,
      public DocumentTitle : string
      ) { }
  }

}




